<template>
  <div>
    <vue-headful :title="getPageTitle(`Project Owner Request`)" />
    <b-loading v-if="isLoading" is-full-page active></b-loading>
    <div class="home-layout" v-if="!this.isLoggedIn">
      <main class="main">
        <div :class="[$style.columns]">
          <div :class="['column', $style.landingTextCol]">
            <div :class="[$style.landingText]" v-if="showAcceptPage">
              <img
                src="@/assets/images/logo_paces@2x.png"
                :class="$style.jbiLogo"
              />
              <p
                v-if="!isReclaimProject"
                :class="$style.AcceptSubscriptionHeaderLabel"
              >
                Project administrator request accepted
              </p>
              <p
                v-if="isReclaimProject"
                :class="$style.AcceptSubscriptionHeaderLabel"
              >
                Project administrator request change accepted
              </p>
              <p
                v-if="!isReclaimProject"
                :class="$style.SubscriptionSubHeaderLabel"
              >
                You are now the project administrator in {{ projectName }}.
              </p>
              <p
                v-if="!isReclaimProject"
                :class="$style.SubscriptionSubHeaderLabel"
              >
                Sign in to view the project.
              </p>
              <p
                v-if="isReclaimProject"
                :class="$style.SubscriptionSubHeaderLabel"
              >
                You have accepted the project administration change request.
              </p>
              <b-button
                rounded
                @click="redirectToProject(projectId, loginUrl, true)"
                :class="[$style.redirectBtn]"
                type="is-primary"
              >
                Sign In
              </b-button>
            </div>
            <div
              :class="
                showDeclinedForm
                  ? [$style.landingText]
                  : [$style.landingTextAfter]
              "
              v-if="showDeclinedPage"
            >
              <img
                src="@/assets/images/logo_paces@2x.png"
                :class="$style.jbiLogo"
              />
              <div v-if="showDeclinedForm">
                <p :class="$style.DeclineSubscriptionHeaderLabel">
                  Decline Project Administration Request
                </p>
                <p :class="$style.SubscriptionSubHeaderLabel">
                  Please enter a reason for declining project administration
                  request for {{ projectName }}. Upon submission,
                  {{ senderName }} will be notified of your reason.
                </p>
                <br />
                <b-input
                  placeholder="Enter your reason here (optional)"
                  v-model="reason"
                  type="textarea"
                >
                </b-input>
                <b-button
                  rounded
                  @click="handleSubmitReason(reason)"
                  :class="[$style.redirectBtn]"
                  type="is-primary"
                >
                  Submit
                </b-button>
              </div>
              <p :class="$style.redirectToJaasLink">
                <a
                  :href="JAAS_LOGIN_URL"
                  @click.prevent="redirectToJaasLogin({ destination: '/' })"
                  >Sign In to PACES</a
                >
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import HomeHeader from '../../views/Home/components/HomeHeader.vue';
import HomeLayout from '../../layouts/HomeLayout.vue';
import { useAction, useAuthState } from '../../utils/store.util';
import { useUserEmail } from '@/utils/user.util';
import { axios } from '../../api/axios';
import { AxiosError, AxiosResponse } from 'axios';
import { ToastProgrammatic as Toast } from 'buefy';
import BaseDialog from '../../components/base/BaseDialog.vue';
import { get as _get } from 'lodash';
import { JAAS_LOGIN_URL, redirectToJaasLogin } from '../../utils/login.util';
import ProjectOwnerRejectForm from '../Project/components/ProjectOwnerRejectForm.vue';

@Component({ components: { HomeHeader, HomeLayout } })
export default class ProjectOwnerRequestInvitation extends Vue {
  public isLoading: boolean = false;
  public showAcceptPage: boolean = false;
  public showDeclinedPage: boolean = false;
  public showDeclinedForm: boolean = false;
  public isRequestAccepted: boolean = false;
  public isReclaimProject: boolean = false;
  public isSelectProjectAdmin: boolean = false;
  public projectId: number = 0;
  public projectOwnerRequestId: number = 0;
  public loginUrl: string = '';
  public projectName: any = '';
  public senderName: string | any = '';
  public reason: string = '';
  public token: any = '';
  public email: any = '';
  public originatorProjectEmail: any = '';

  get isLoggedIn(): boolean {
    return useAuthState.call(this).isLoggedIn;
  }

  get switchAccount() {
    return useAction.call(this, 'auth/switchAccount');
  }

  get signOut() {
    return useAction.call(this, 'auth/signOut');
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  get JAAS_LOGIN_URL(): string {
    return JAAS_LOGIN_URL;
  }

  get redirectToJaasLogin() {
    return redirectToJaasLogin;
  }

  public redirectToProject(projectId: number, loginUrl: string) {
    this.showDeclinedPage = false;
    this.showDeclinedForm = false;
    if (this.isLoggedIn) {
      if (this.email === this.userEmail) {
        this.$router.push({
          path: `/projects/${projectId}#participants`,
        });
      } else {
        this.logoutMismatchUser();
      }
    } else {
      redirectToJaasLogin({
        destination: `/projects/${projectId}#participants`,
        loginUrl,
      });
    }
  }

  public submitModalDecline(info: any) {
    this.$router.replace('/');
    this.$buefy.modal.open({
      parent: this,
      props: {
        notificationSenderName: info.senderName,
        projectName: info.projectName,
      },
      events: {
        confirm: async (newValue: any) => {
          this.respondProjectOwnerRequest(newValue);
        },
      },
      component: ProjectOwnerRejectForm,
      hasModalCard: true,
    });
  }

  public handleSubmitReason(declineReason: any) {
    this.isLoading = true;
    const payload = {
      token: this.$route.query.token || this.token,
      email: this.$route.query.email || this.email,
      originatorProjectEmail:
        this.$route.query.originatorProjectEmail || this.originatorProjectEmail,
      projectId: this.$route.query.projectId || this.projectId,
      isLoggedIn: this.isLoggedIn,
      isRequestAccepted: this.isRequestAccepted,
      isReclaimProject: this.isReclaimProject,
    };
    return axios
      .post(`project-owner-request/updateDeclineProjectOwnerRequest`, {
        ...payload,
      })
      .then((response: AxiosResponse) => {
        Toast.open({
          queue: true,
          type: 'is-dark',
          position: 'is-top',
          message: `Project administration request successfully declined with reason.`,
        });
        this.respondProjectOwnerRequest(declineReason);
        this.showDeclinedPage = true;
        this.showDeclinedForm = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  public respondProjectOwnerRequest(declineReason: any) {
    this.projectName = this.$route.query.projectName;
    const rejectReason = declineReason ? declineReason : null;
    const payload = {
      token: this.$route.query.token || this.token,
      email: this.$route.query.email || this.email,
      originatorProjectEmail:
        this.$route.query.originatorProjectEmail || this.originatorProjectEmail,
      projectId: this.$route.query.projectId || this.projectId,
      isLoggedIn: this.isLoggedIn,
      isRequestAccepted: this.isRequestAccepted,
      reason: rejectReason,
      isReclaimProject: this.isReclaimProject,
    };
    return axios
      .post(`project-owner-request/updateProjectOwnerRequest`, {
        ...payload,
      })
      .then((response: AxiosResponse) => {
        if (this.isRequestAccepted) {
          if (this.isLoggedIn) {
            let toastMessage: string = '';
            if (this.isReclaimProject) {
              toastMessage = `You have accepted the project administration change request`;
            } else {
              toastMessage = `You are now the project administrator in ‘${this.$route.query.projectName}'.`;
            }
            Toast.open({
              queue: true,
              type: 'is-dark',
              position: 'is-top',
              message: toastMessage,
            });
            this.$router.push({
              path: `/projects/${payload.projectId}#dashboard`,
            });
          } else {
            this.showAcceptPage = true;
          }
        } else {
          if (this.isLoggedIn) {
            Toast.open({
              queue: true,
              type: 'is-dark',
              position: 'is-top',
              message: `Project administration request successfully declined.`,
            });
          }
        }
      })
      .catch((error: AxiosError) => {
        this.isLoading = false;
        if (error.response!.status === 409) {
          this.$buefy.modal.open({
            parent: this,
            component: BaseDialog,
            hasModalCard: true,
            trapFocus: true,
            props: {
              title: 'Invitation link is not valid',
              content:
                'Your request link is not valid for the MyJBI account you are signed in to. Please sign in with the email address the invitation was sent to instead.',
              confirmButtonText: 'Logout',
            },
            events: {
              confirm: async () => {
                await this.switchAccount(true);
                await this.signOut();
              },
              cancel: () => {
                this.$router.replace('/');
              },
            },
          });
        } else {
          Toast.open({
            queue: true,
            type: 'is-danger',
            position: 'is-top',
            message: `${_get(error.response, 'data.message')}`,
          });
          this.$router.replace('/');
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  public logoutMismatchUser() {
    this.isLoading = false;
    this.$buefy.modal.open({
      parent: this,
      component: BaseDialog,
      hasModalCard: true,
      trapFocus: true,
      props: {
        title: 'Invitation link is not valid',
        content:
          'Your request link is not valid for the MyJBI account you are signed in to. Please sign in with the email address the invitation was sent to instead.',
        confirmButtonText: 'Logout',
      },
      events: {
        confirm: async () => {
          await this.switchAccount(true);
          await this.signOut();
        },
        cancel: () => {
          this.$router.replace('/');
        },
      },
    });
  }

  public respondDeclineProjectOwnerRequest() {
    if (this.isSelectProjectAdmin) {
      this.redirectToProject(this.projectId, this.loginUrl);
    } else {
      const declineInfo = {
        senderName: this.senderName,
        projectName: this.projectName,
      };
      this.submitModalDecline(declineInfo);
    }
  }

  public mounted() {
    this.isLoading = true;
    this.token = this.$route.query.token.toString();
    this.email = this.$route.query.email.toString();
    this.originatorProjectEmail = this.$route.query.originatorProjectEmail.toString();
    this.senderName = this.$route.query.senderName;
    this.projectId = Number(this.$route.query.projectId);
    this.projectOwnerRequestId = Number(
      this.$route.query.projectOwnerRequestId,
    );
    this.loginUrl = this.$route.query.loginUrl.toString();
    this.projectName = this.$route.query.projectName;
    this.isRequestAccepted = JSON.parse(
      this.$route.query.isAcceptRequest.toString(),
    );
    this.isReclaimProject = JSON.parse(
      this.$route.query.isReclaimProject.toString(),
    );
    this.isSelectProjectAdmin = JSON.parse(
      this.$route.query.isSelectProjectAdmin.toString(),
    );

    if (this.isSelectProjectAdmin) {
      // selectProjectAdmin requires login
      if (!this.isLoggedIn) {
        redirectToJaasLogin({
          destination: this.$route.fullPath,
          loginUrl: this.loginUrl,
        });
        this.isLoading = false;
        return;
      }
      this.redirectToProject(this.projectId, this.loginUrl);
      return;
    }

    if (this.isRequestAccepted) {
      // Accept always requires login — redirect if not logged in
      if (!this.isLoggedIn) {
        redirectToJaasLogin({
          destination: this.$route.fullPath,
          loginUrl: this.loginUrl,
        });
        this.isLoading = false;
        return;
      }
      // Logged in — verify email matches before accepting
      this.$nextTick(() => {
        if (
          !this.userEmail ||
          this.email.toLowerCase() !== this.userEmail.toLowerCase()
        ) {
          this.logoutMismatchUser();
          return;
        }
        this.respondProjectOwnerRequest(this.reason);
      });
      return;
    }

    // Decline path
    if (this.isLoggedIn) {
      // Logged in — verify email matches before declining
      this.$nextTick(() => {
        if (
          !this.userEmail ||
          this.email.toLowerCase() !== this.userEmail.toLowerCase()
        ) {
          this.logoutMismatchUser();
          return;
        }
        this.respondDeclineProjectOwnerRequest();
      });
    } else {
      // Not logged in — show inline decline form (original behaviour preserved)
      this.showDeclinedPage = true;
      this.showDeclinedForm = true;
      this.isLoading = false;
    }
  }
}
</script>

<style lang="scss" module>
.container {
  height: 100%;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
}

.default-layout {
  display: none !important;
}
.landingWrapper {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.columns {
  height: 100%;
  padding-right: 600px;
  display: flex;
  flex: 1 1 0;
}

.landingTextCol {
  display: flex;
  justify-content: center;
  margin-left: 560px;
  margin-top: 250px;
  text-align: center;
}

.landingText {
  padding-bottom: 130px;
}

.landingTextAfter {
  padding-bottom: 130px;
  margin-left: 150px;
  margin-top: 130px;
}

.landingPagePic {
  height: 100%;
  background-image: url('~@/assets/images/landing/paces_home_banner.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.jbiLogo {
  padding-bottom: 60px;
}

.DeclineSubscriptionHeaderLabel {
  color: #444f51;
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  text-align: center;
}

.AcceptSubscriptionHeaderLabel {
  color: #444f51;
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  text-align: center;
}

.SubscriptionSubHeaderLabel {
  padding-top: 10px;
  color: #444f51;
  font-size: 16px;
  line-height: 19px;
}
.redirectBtn {
  margin-top: 50px;
  color: #ffffff;
  font-size: 18px;
  padding: 12px 20px;
}
.redirectToJaasLink {
  color: #00205b;
  font-size: 14px;
  line-height: 17px;
  padding-top: 40px;
  font-weight: bold;
}
.logoutLink {
  color: #00205b;
  font-size: 14px;
  line-height: 17px;
  padding-top: 24px;
  font-weight: bold;
}
</style>
